import React, { useState } from 'react';
import { Clock, Calendar, Play } from 'lucide-react';
import api from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Badge } from './ui/badge';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export default function GapFillingWidget() {
  const [gaps, setGaps] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const navigate = useNavigate();

  const fetchGaps = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/schedules/gaps?date=${selectedDate}`);
      setGaps(response.data);
    } catch (error) {
      toast.error('Erro ao calcular');
    } finally {
      setLoading(false);
    }
  };

  const formatMin = (m) => m >= 60 ? `${Math.floor(m/60)}h ${m%60}min` : `${m}min`;

  return (
    <Card className="shadow-md border-2 border-blue-200 dark:border-blue-800" data-testid="gap-filling">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg text-slate-900 dark:text-slate-100">
          <Clock className="w-5 h-5 text-blue-600" />
          Tempo Livre
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex gap-2">
          <Input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} className="flex-1" />
          <Button onClick={fetchGaps} disabled={loading}>
            {loading ? '...' : <Calendar className="w-4 h-4" />}
          </Button>
        </div>

        {gaps && (
          <>
            <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg text-center">
              <span className="text-lg font-bold text-blue-600">{formatMin(gaps.total_available_minutes)}</span>
              <span className="text-sm text-slate-600 dark:text-slate-400 ml-2">disponíveis</span>
            </div>

            {gaps.windows.length === 0 ? (
              <p className="text-sm text-slate-500 text-center">Nenhuma janela livre</p>
            ) : (
              <div className="space-y-2 max-h-48 overflow-y-auto">
                {gaps.windows.map((w, i) => (
                  <div key={i} className="p-3 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800">
                    <div className="flex justify-between items-center mb-2">
                      <span className="font-medium text-slate-900 dark:text-slate-100">{w.start_time} - {w.end_time}</span>
                      <Badge variant="outline">{formatMin(w.duration_minutes)}</Badge>
                    </div>
                    {w.suggested_content?.length > 0 && (
                      <div className="flex flex-wrap gap-1">
                        {w.suggested_content.map((c) => (
                          <Button key={c.id} size="sm" variant="ghost" className="h-6 text-xs" onClick={() => navigate(`/topics/${c.id}`)}>
                            <Play className="w-3 h-3 mr-1" />{c.title}
                          </Button>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
